<template>
  <page-header-wrapper>
    <a-card :bordered="false">
      <wire-transfer-configuration />
    </a-card>
  </page-header-wrapper>
</template>

<script>
import WireTransferConfiguration from './modules/WireTransferConfiguration'

export default {
  name: 'Bank',
  components: { WireTransferConfiguration }
}
</script>
